module.exports = __webpack_public_path__ + "static/img/Regina_Health-Equity_low_a.1bdf396.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/introduction/Regina_Health-Equity_low_a.jpg
// module id = SfA+
// module chunks = 0